import React from "react";
import { connect } from "react-redux";
// import firebase from "../../../firebase";

import Banner from "../../../sections/Banner/Banner";
import VideoCard from "../../../components/VideoCard/VideoCard";
import LoginOnly from "../../../sections/LoginOnly/LoginOnly";

import circuits from "./circuits.json";
import "./Circuits.css";

const Circuits = (props) => {
  return (
    <div>
      <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/men-birddog.jpg"
        img_alt="Men's Team working out near the Washington Monument."
      >
        <h1>Strength & Conditioning</h1>
      </Banner>
      <section className="Circuits">
        <LoginOnly>
          {circuits.map((circuit) => (
            <VideoCard full key={circuit.title} videoId={circuit.youtubeId}>
              <h3>{circuit.title}</h3>
              <p>{circuit.description}</p>
              <div className="b">TIPS</div>
              <ul>
                {circuit.tips.map((tip) => (
                  <li>{tip}</li>
                ))}
                <li>
                  <span className="b">Equipment:</span> {circuit.equipment}
                </li>
              </ul>
              {/* <p>
                <span className="b upper">Equipment:</span> {circuit.equipment}
              </p> */}
            </VideoCard>
          ))}
          {/* <VideoCard videoId="6m41Gdya9PM">
            <h3>Warm Up Circuit</h3>
          </VideoCard>
          <VideoCard videoId="Z0l7xzR0rIo">
            <h3>Snell Circuit</h3>
          </VideoCard>
          <VideoCard videoId="D5KKsy3IXrw">
            <h3>Berto Circuit</h3>
          </VideoCard> */}
        </LoginOnly>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userId: state.userId,
  };
};

export default connect(mapStateToProps)(Circuits);
